// Side-effect module: registers every dayjs plugin the app relies on.
// Imported once from src/index.tsx so the global dayjs singleton is set up
// before any antd DatePicker / Calendar (which call .weekday() etc.) or
// app code (.tz, .utc) runs.

import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";

// antd v5 DatePicker/Calendar requirements.
dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

// App requirements (timezone-aware change requests, etc.).
dayjs.extend(utc);
dayjs.extend(timezone);
